/* eslint-disable react-hooks/exhaustive-deps */
import { loader } from 'graphql.macro';
import React, { forwardRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Avatar from '../avatar/Avatar';
import { executeGraphqlSubscribe } from '../../graphql/api';
import { SAIcon, SAIcons, SAIconSize } from '@saux/design-system-react';
import pinIcon from '../../icons/PinIcon.png';
import { fetchCustomerDetails, fetchParticipants, formatSelectedConversation, updateParticipantsSubscriptionData, updateReadMessages } from '../../store/actions/conversationActions';
import { handleSubscriptionError, isConversationViewer, isNotEmpty } from '../../utils/utilities';
import { CUSTOMER, NEW } from '../../utils/constants';

const addParticipantSubscriptionQuery = loader("../../graphql/subscriptions/addParticipantById.graphql");
const deleteParticipantSubscriptionQuery = loader("../../graphql/subscriptions/deleteParticipantById.graphql");


const ChatListItems = forwardRef((props: any, ref: any) => {
  const selected_conversation = useSelector((state: any) => state.chat.selectedConversation);
  const user = useSelector((state: any) => state.user);
  const unreadMsgCount = useSelector((state: any) => state.chat.unreadMsgCount);
  let unreadMsgs = (isNotEmpty(unreadMsgCount) && unreadMsgCount[props.conversation?.conversationId]);
  let customer = props.conversation?.participants && props.conversation?.participants.find((con: any) => con.participantType === CUSTOMER);
  const dispatch = useDispatch();
  let addParticipantSubscription: any;
  let removeParticipantSubscription: any;

  useEffect(() => {
    // subscribeToMessage();
    subscribeToAddParticipant();
    subscribeToDeleteParticipant();
    dispatch(fetchParticipants(props.conversation?.conversationId));
    return () => {
      // messageSubscription.unsubscribe();
      addParticipantSubscription.unsubscribe();
      removeParticipantSubscription.unsubscribe();
    }
  }, []);

  const subscribeToAddParticipant = () => {
    addParticipantSubscription = executeGraphqlSubscribe(addParticipantSubscriptionQuery, { conversationId: props.conversation?.conversationId })
      .subscribe({
        next: ({ provider, value }: any) => {
          let response = value?.data?.onAddParticipantByconversationId;
          dispatch(updateParticipantsSubscriptionData(response))
        },
        error: ({ error, provider }: any) => {
          handleSubscriptionError(error);
        }
      })
  }

  const subscribeToDeleteParticipant = () => {
    removeParticipantSubscription = executeGraphqlSubscribe(deleteParticipantSubscriptionQuery, { conversationId: props.conversation?.conversationId })
      .subscribe({
        next: ({ provider, value }: any) => {
          let response = value?.data?.onDeleteParticipantByconversationId;
          dispatch(updateParticipantsSubscriptionData(response))
        },
        error: ({ error, provider }: any) => {
          handleSubscriptionError(error);
        }
      })
  }

  const selectedChat = (conversation: any) => {
    if (selected_conversation?.conversationId !== conversation.conversationId) {
      dispatch(formatSelectedConversation(conversation));
      dispatch(fetchParticipants(conversation.conversationId));
     // dispatch(fetchCustomerDetails(conversation.conversationId));
      props.toggleAnimation();
      if (!isConversationViewer()) {
        dispatch(updateReadMessages({
          conversationId: selected_conversation?.conversationId,
          adjusterId: user.email
        }))
      }
    }
  }

  function handleMenuOptions(event: React.MouseEvent<HTMLElement>) {
    props.setReferenceElement(event.currentTarget);
  }

  return (
    <div
      onClick={() => selectedChat(props.conversation)}
      className={`chatlist-item ${props.active ? "active" : ""}`}
      key={props.index}
      data-testid="chatlist-item"
      ref={ref}
    >
      <div className="profile-info" data-testid="profile-info">
        <Avatar
          name={customer?.name}
        />
        {unreadMsgs ?
          <Avatar
            style={{ width: 20, height: 20, left: 35, top: 13, position: "absolute", backgroundColor: "red" }}
            fontSize={10}
            symbol={unreadMsgCount[props.conversation?.conversationId]}
          /> : null}
        {props.conversation?.pinStatus === true ?
          <img
            style={{ width: 20, height: 20, left: 13, top: 45, position: "absolute" }}
            src={pinIcon}
            alt={""}
          /> : null}
        <div className={`userMeta ${unreadMsgs ? "unread" : ""}`}>
          <p>{customer?.name}</p>
          <span>{props.conversation && props.conversation.claimNumber}</span>
        </div>
        {props.conversation?.conversationId !== NEW && props.menuOptions && <div className="menu-icon" data-testid="menu-icon">
          <SAIcon data-testid="menu-options" icon={SAIcons.menuKabob} size={SAIconSize.medium} colorVariant="dark" onClick={handleMenuOptions} />
        </div>}
      </div>
    </div>
  );
})

export default ChatListItems;